module.exports = __webpack_public_path__ + "static/media/qc-bg.d24f20cd.png";